/* FREESHIP = parcels shipped by an outsourcing partner. */
export const isOutsourced = (mode) => (mode || "").toUpperCase().startsWith("FREESHIP");

export const OutsourcedTag = ({ mode, testid }) => isOutsourced(mode) ? (
  <span className="ml-1 inline-block rounded bg-teal-100 px-1 py-px text-[9px] font-bold uppercase text-teal-800 align-middle"
    title="Shipped by outsourcing partner" data-testid={testid || "outsourced-tag"}>Outsourced</span>
) : null;
